import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import projectDetailsCss from "./ProjectDetails.module.css";
import RestClient from "../../RestApi/RestClient";
import AppUrl from "../../RestApi/AppUrl";
import { useParams } from "react-router-dom";
export default function ProjectDetails() {
  const [data, setData] = useState({
    image: "",
    projectName: "",
    projectDes: "",
  });
  const { id } = useParams();
  console.log(data);
  useEffect(() => {
    RestClient.GetRequest(AppUrl.ProjectDetails + id).then((result) =>
      setData({
        image: result[0]["img_one"],
        projectName: result[0]["project_name"],
        projectDes: result[0]["project_description"],
      })
    );
  }, []);
  return (
    <>
      <div className={`${projectDetailsCss.detailsArea}`}>
        <Container>
          <div className="detailsAreaInner">
            <Row>
              <Col lg={6} md={6} sm={12}>
                <div
                  class="about-thumb-wrap after-shape"
                  className={`${projectDetailsCss.pageDetailThumb} ${projectDetailsCss.afterShape}`}
                  style={{ backgroundImage: `url(${data.image})` }}
                ></div>
              </Col>
              <Col lg={6} md={6} sm={12}>
                <div className={`${projectDetailsCss.detailsAboutWrap}`}>
                  <div className={`${projectDetailsCss.sectionTitle} mb-0`}>
                    {/* <h6 className={`${projectDetailsCss.subTitle}`}>
                      ABOUT US
                    </h6> */}
                    <h2 className={`${projectDetailsCss.title}`}>
                      {data.projectName}
                    </h2>
                    <p className={`${projectDetailsCss.content}`}>
                      {data.projectDes}
                    </p>
                    <Row>
                      <Col lg={6} md={6} sm={6}>
                        <ul className={`${projectDetailsCss.singleListwrap}`}>
                          <li class="single-list-inner style-check-box">
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              className={`${projectDetailsCss.icon}`}
                            />{" "}
                            Metus interdum metus
                          </li>
                          <li class="single-list-inner style-check-box">
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              className={`${projectDetailsCss.icon}`}
                            />{" "}
                            Ligula cur maecenas
                          </li>
                          <li class="single-list-inner style-check-box">
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              className={`${projectDetailsCss.icon}`}
                            />{" "}
                            Fringilla nulla
                          </li>
                        </ul>
                      </Col>
                      <Col lg={6} md={6} sm={6}>
                        <ul className={`${projectDetailsCss.singleListwrap}`}>
                          <li class="single-list-inner style-check-box">
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              className={`${projectDetailsCss.icon}`}
                            />{" "}
                            Metus interdum metus
                          </li>
                          <li class="single-list-inner style-check-box">
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              className={`${projectDetailsCss.icon}`}
                            />{" "}
                            Ligula cur maecenas
                          </li>
                          <li class="single-list-inner style-check-box">
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              className={`${projectDetailsCss.icon}`}
                            />{" "}
                            Fringilla nulla
                          </li>
                        </ul>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
}
